import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

export const mutation = gql`
  mutation AdvocateLoginWithEmail($email: String!, $password: String!) {
    advocateLoginWithEmail(email: $email, password: $password) {
      token
      token_expires_at_iso
      refresh_token
      refresh_token_expires_at_iso
      message
      remained_attempts
      locked
      authenticated
      user {
        id
        full_name
      }
    }
  }
`

export default function useSignIn() {
  const { onMutate: onSignIn, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'advocateLoginWithEmail',
    successMessage: ''
  })
  return { onSignIn, loading }
}
